import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import drop_down_icon from "../assets/icons/drop_down_icon.png";
import email_icon from "../assets/icons/email_icon.png";
import whatsapp_icon from "../assets/icons/whatsapp_icon.png";
import edit_pencil_icon from "../assets/icons/edit_pencil_icon.png";
import attachment_pin_icon from "../assets/icons/attachment_pin_icon.png";
import { Link } from "react-router-dom";
import search_button_icon from "../assets/icons/search_button_icon.png";
import india_flag_icon from "../assets/icons/india_flag_icon.png";
import ExhibitionUsersFilters from "../components/ExhibitionUsersFilters";

const ExhibitionDetails = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [inviteToggle, setInviteToggle] = useState(true);
  const [exhibitionToggle, setExhibitionToggle] = useState(true);
  const [contactToggle, setContactToggle] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [showSecondMobileNumber, setShowSecondMobileNumber] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleInviteToggle = () => {
    setInviteToggle(!inviteToggle);
  };

  const handleExhibitionToggle = () => {
    setExhibitionToggle(!exhibitionToggle);
  };

  const handleContactToggle = () => {
    setContactToggle(!contactToggle);
  };

  const handleFilterOpen = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Tasks" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex justify-between">
        <div className="ml-4 w-[70%] exhibition-details">
          <div className="flex mt-4">
            <p className="text-[14px] mr-2">Exhibition Name 1</p>
            <div>
              <img src={drop_down_icon} alt="drop down" />
            </div>
          </div>

          <div className="mt-2">
            <p className="text-[14px]">Exhibition Name</p>
            <input
              type="text"
              placeholder="Exhibition Name 1"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">Start Date</p>
            <input
              type="text"
              placeholder="October 23, 2023"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">End Date</p>
            <input
              type="text"
              placeholder="October 25, 2023"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">Tags</p>
            <div className="border w-full p-2 rounded-lg  border-[#5EB0E7] text-[16px] flex">
              <div className="flex items-center justify-center text-[14px] border border-[#95C2FF] rounded-xl bg-[#D4F0FF] w-[10rem]">
                Traditional Wear{" "}
                <span className="text-[20px] ml-2">&#xd7;</span>
              </div>
              <div className="flex items-center justify-center text-[14px] border border-[#95C2FF] rounded-xl bg-[#D4F0FF] w-[10rem] ml-2">
                Indian Wear <span className="text-[20px] ml-2">&#xd7;</span>
              </div>
            </div>
          </div>

          <div className="mt-2">
            <p className="text-[14px]">Location</p>
            <input
              type="text"
              placeholder="Flat No. 302, Sunshine Apartments, Mahatma Gandhi Road, Mumbai, Maharashtra 400001,India"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>

          <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[12px]">Invites</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={inviteToggle}
                    onChange={handleInviteToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>

            {inviteToggle ? (
              <div className="mt-4 flex flex-col justify-between">
                <div className="flex w-full justify-between">
                  <div className="text-[#344054] border border-[#344054] text-[12px] bg-[#F2F4F7] w-[49%] flex justify-center items-center rounded-xl p-2">
                    <img src={email_icon} alt="email icon" className="mr-2" />
                    <p>Emails</p>
                  </div>
                  <div className="text-[#3485BB] border border-[#3485BB] text-[12px] bg-[#EFF8FF] w-[49%] flex justify-center items-center rounded-xl">
                    <img
                      src={whatsapp_icon}
                      alt="whatsapp icon"
                      className="mr-2"
                    />
                    <p>Whatsapp</p>
                    <span className="text-[20px] ml-2">&#xd7;</span>
                  </div>
                </div>

                <div className="bg-white mt-4 border p-4 rounded-lg">
                  <div className="flex justify-between">
                    <p className="text-[14px] font-bold">
                      Whatsapp invite message template
                    </p>
                    <img
                      src={edit_pencil_icon}
                      alt="edit"
                      className="object-contain w-4"
                    />
                  </div>
                  <p className="text-[#91929E] text-[12px] mt-2">
                    This is a dummy text message just to...
                  </p>
                  <div className="flex items-center mt-2">
                    <div>
                      <img
                        src={attachment_pin_icon}
                        alt="attachment"
                        className="w-10 cursor-pointer"
                      />
                    </div>
                    <div className="ml-2 text-[#828282] text-[12px]">
                      Attach for invite
                    </div>
                  </div>
                </div>
                <div className="text-center text-[#2F80ED] text-[14px] underline mt-2 cursor-pointer">
                  Share on social media
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[12px]">Exhibition Cost</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={exhibitionToggle}
                    onChange={handleExhibitionToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            {exhibitionToggle ? (
              <div>
                <p className="text-[14px] font-bold mt-2">Rental</p>
                <input type="range" className="w-full" min={0} max={100} />
                <div className="flex justify-between text-[12px]">
                  <p className="bg-[#EFEFEF] border p-1">10,000</p>
                  <p className="bg-[#EFEFEF] border p-1">10,000,00</p>
                </div>
                <div className="text-[14px] text-[#2F80ED] underline text-center">
                  +Add Other Expenses
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[12px]">Contact Details</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={contactToggle}
                    onChange={handleContactToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            <div className="mt-2">
              <p className="text-[14px] text-[#828282]">Profession</p>
              <div className="flex">
                <select
                  name="Search & select contact person"
                  className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Search & select contact person
                  </option>
                  <option value="Praveen Sharma">Praveen Sharma</option>
                </select>
                <div onClick={handleFilterOpen}>
                  <img
                    src={search_button_icon}
                    alt="search icon"
                    className="w-8  object-contain ml-2 cursor-pointer"
                  />
                </div>
              </div>
            </div>

            <div className="mt-2">
              <p className="text-[14px] text-[#828282]">Content Person</p>
              <div className="flex">
                <select
                  name="Search & select contact person"
                  className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select the contact person
                  </option>
                  <option value="Praveen Sharma">Praveen Sharma</option>
                </select>
              </div>
            </div>

            <p className="text-[14px] text-[#828282] mt-4">Mobile Number</p>
            <div className="flex border w-full border-[#95C2FF] p-2 rounded-lg">
              <img
                src={india_flag_icon}
                alt="india flag"
                className="cursor-pointer"
              />
              <input
                type="number"
                placeholder="Enter the number"
                className="text-[16px] w-full ml-2"
              />
            </div>

            <div className="flex items-center mt-1">
              <input
                type="checkbox"
                onChange={() =>
                  setShowSecondMobileNumber(!showSecondMobileNumber)
                }
              />
              <p className="text-[14px] ml-1">Whatsapp number is not similar</p>
            </div>
            {showSecondMobileNumber && (
              <div>
                <p className="text-[14px] text-[#828282] mt-4">Mobile Number</p>
                <div className="flex border w-full border-[#95C2FF] p-2 rounded-lg">
                  <img
                    src={india_flag_icon}
                    alt="india flag"
                    className="cursor-pointer"
                  />
                  <input
                    type="number"
                    placeholder="Enter the number"
                    className="text-[16px] w-full ml-2"
                  />
                </div>
              </div>
            )}
            <p className="text-[14px] text-[#828282] mt-4">Email Address</p>
            <input
              type="email"
              placeholder="Enter the email address"
              className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
            />
          </div>

          <div className="mb-10">
            <div className=" mt-4 flex w-full justify-between items-center create-foot">
              <div className="text-[#2F80ED] text-[16px] underline font-bold cursor-pointer mt-8">
                Save & Create New
              </div>
              <div className="flex text-[14px] w-[50%] justify-end mt-8">
                <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[30%] action--buttons">
                  Discard
                </button>
                <Link
                  to="/exhibition/exhibitionUserRedirectPage"
                  className="bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[30%] text-center action--buttons"
                >
                  Send
                </Link>
              </div>
            </div>
          </div>
        </div>

        {isFilterOpen ? (
          <div className="w-[25%] mt-10">
            <ExhibitionUsersFilters />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ExhibitionDetails;
